export const normalizePhoneNumber = value => {
  if (value == null) return '';

  const trimmedValue = value.trim();
  const digitsOnly = trimmedValue.replace(/\D/g, '');

  if (digitsOnly === '') return '';
  if (trimmedValue.startsWith('+')) return `+${digitsOnly}`;
  if (digitsOnly.length === 10) return `+1${digitsOnly}`;
  return `+${digitsOnly}`;
};

export const formatPhoneNumberForDisplay = value => {
  const normalizedValue = normalizePhoneNumber(value);
  if (!/^\+\d{10,15}$/.test(normalizedValue)) return value || '';

  const digitsOnly = normalizedValue.slice(1);

  if (digitsOnly.length === 11 && digitsOnly[0] === '1') {
    const nationalNumber = digitsOnly.slice(1);
    return `(${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
  }

  return normalizedValue;
};

export const isValidPhoneNumber = value => {
  if (value == null || value === '') return false;
  return /^\+\d{10,15}$/.test(normalizePhoneNumber(value));
};
